import { STATE_INITIAL } from 'Store/commonActions';
import { initialChatSuggestionsState } from 'Store/match/constants';

import type { MatchState } from './types';

const initialState: MatchState = {
  archivedMatches: [],
  matches: [],
  typingIndicators: {},
  chatSuggestions: {
    chatSuggestionsStatus: STATE_INITIAL,
    ...initialChatSuggestionsState,
  },
  expiration: {
    matchListTooltipShown: false,
    messageListTooltipShown: false,
  },
};

export default initialState;
